module.exports = __webpack_public_path__ + "img/NewfoundCourage.e2aac469.jpg";